import { Component, OnInit } from '@angular/core';
import { translate } from "@ngneat/transloco";

@Component({
  selector: 'preview-details',
  templateUrl: './preview-details.component.html',
  styleUrls: ['./preview-details.component.scss']
})
export class PreviewDetailsComponent implements OnInit {

  tabs: any[];
  activeTab: any;
  previewProperties: any[];

  constructor() { }

  ngOnInit(): void {
    this.previewProperties = [
      {name: 'MAC_ADDRESS', value: 'C8-5A-BF-3E-6C-05'},
      {name: 'LOCATION', value: '39.9771, -0.0296'},
      {name: 'ACTIVE', value: 'true'}
    ];
    this.tabs = [
      {id: "overview", label: translate('preview.overview'), icon: 'pi pi-home'},
      {id: "sensors", label: translate('preview.sensors'), icon: 'pi pi-wifi'},
      {id: "measures", label: translate('preview.measures'), icon: 'pi pi-chart-bar'},
      {id: "triggers", label: translate('preview.triggers'), icon: 'pi pi-exclamation-triangle'},
      {id: "events", label: translate('preview.events'), icon: 'pi pi-exclamation-circle'},
    ];
    this.activeTab = this.tabs[0];
  }

}
